export const ROUTES = [
  { path: '/', label: 'HOME' },
  { path: '/about', label: 'ABOUT' },
  { path: '/services', label: 'SERVICES' },
  { path: '/gallery', label: 'GALLERY' },
  { path: '/contact', label: 'CONTACT' },
];

export const RESERVATION_ROUTE = '/booking';

export const INDEX_FOR_MENU = 1;
